import { lazy } from "react";
import * as roles from "../catalogs/roles";

/* 
  Routes can be enabled only for specific roles adding a property roles: ['Role1', 'Role2']:

  const routes = [
    {
      path: '/mypath',
      component: lazy(() => import("../ComponentPath")),
      context: "database context" (not mandatory)
      roles: [roles.AZET, roles.INVESTOR]
    }
  ]
*/

/*
IMPORTANT - HOW TO CONFIGURE
Routes must contain path, component and roles. users is optional.
Roles should contain one or more of the allowed roles.
Users could contain one or more emails. If users value is set, only the specified users will have acces to the route.
Context is used to switch database servers. CONFIGURE IT ONLY IF THE API CONTROLLER ALLOWS MULTIPLE DATABASE CONTEXTS. Should contain only one database context.
    values: 
          "DDInstance": connect to ddinstance database server 
          "Instance" or not configure: connect to default database server
*/

const routes = [
  {
    path: "/",
    component: lazy(() => import("../views/Home/Home")),
    exact: true,
    roles: [roles.AZET]
  },
  {
    path: "/home",
    component: lazy(() => import("../views/Home/Home")),
    roles: [roles.AZET]
  },
  {
    path: "/changepassword",
    component: lazy(() => import("../views/ChangePassword/ChangePassword")),
    roles: [roles.AZET]
  },
  // {
  //   path: "/invoices",
  //   component: lazy(() => import("../views/Invoices/Invoices")),
  //   roles: [roles.AZET]
  // },
  // {
  //   path: "/loanschedules",
  //   component: lazy(() => import("../views/LoanSchedules/LoanSchedules")),
  //   roles: [roles.AZET]
  // },
  // {
  //   path: "/loantapes",
  //   context: "DDInstance",
  //   component: lazy(() => import("../views/LoanTapes/LoanTapes")),
  //   roles: [roles.AZET]
  // },
  // {
  //   path: "/advanceRequests",
  //   component: lazy(() => import("../views/AdvanceRequests/AdvanceRequests")),
  //   roles: [roles.AZET]
  // },
  // {
  //   path: "/waivers",
  //   component: lazy(() => import("../views/Waivers/Waivers")),
  //   roles: [roles.AZET]
  // },
  {
    path: "/notifications",
    component: lazy(() => import("../views/Notifications/Notifications")),
    roles: [roles.AZET]
  },
  {
    path: "/backoffice/accountmovements",
    component: lazy(() => import("../views/BackOffice/AccountMovements/AccountMovements")),
    roles: [roles.AZET]
  },
  {
    path: "/backoffice/accounts",
    component: lazy(() => import("../views/BackOffice/Accounts/Accounts")),
    roles: [roles.AZET]
  },
  // {
  //   path: "/backoffice/approvalRequest",
  //   component: lazy(() => import("../views/BackOffice/ApprovalRequest/ApprovalRequest")),
  //   roles: [roles.AZET]
  // },  
  // {
  //   path: "/backoffice/covenantWaivers",
  //   component: lazy(() => import("../views/BackOffice/CovenantWaivers/CovenantWaivers")),
  //   roles: [roles.AZET]
  // },
  // {
  //   path: "/backoffice/datasets",
  //   component: lazy(() => import("../views/BIDashboards/Datasets")),
  //   roles: [roles.AZET]
  // },
  {
    path: "/backoffice/facilities",
    component: lazy(() => import("../views/BackOffice/Facilities/Facilities")),
    roles: [roles.AZET]
  },
  {
    path: "/backoffice/facility/:facilityId",
    component: lazy(() => import("../views/BackOffice/Facilities/components/Facilities/Facility")),
    roles: [roles.AZET]
  },
  {
    path: "/backoffice/facilitydocuments",
    component: lazy(() => import("../views/BackOffice/FacilityDocuments/FacilityDocuments")),
    roles: [roles.AZET]
  },
  // {
  //   path: "/backoffice/facilityMarktomarkethedge",
  //   component: lazy(() => import("../views/BackOffice/MarkToMarketHedge/FacilityMarkToMarketHedge")),
  //   roles: [roles.AZET]
  // },
  {
    path: "/backoffice/partnerdocuments",
    component: lazy(() => import("../views/BackOffice/PartnerDocuments/PartnerDocuments")),
    roles: [roles.AZET]
  },
  {
    path: "/backoffice/partners",
    context: "Instance",
    component: lazy(() => import("../views/BackOffice/Partners/Partners")),
    roles: [roles.AZET]
  }, 
  {
    path: "/backoffice/partner/:partnerId",
    context: "Instance",
    component: lazy(() => import("../views/BackOffice/Partners/components/Partners/Partner")),
    roles: [roles.AZET]
  },  
  // {
  //   path: "/backoffice/paymentdeletionrequests",
  //   component: lazy(() => import("../views/BackOffice/PaymentDeletionRequests/PaymentDeletionRequests")),
  //   roles: [roles.AZET]
  // },
  // {
  //   path: "/backoffice/pledgedloans",
  //   component: lazy(() => import("../views/BackOffice/PledgedLoans/PledgedLoans")),
  //   roles: [roles.AZET]
  // },
  // {
  //   path: "/backoffice/usermanuals",
  //   component: lazy(() => import("../views/BackOffice/UserManuals/UserManuals")),
  //   roles: [roles.AZET]
  // }, 
  {
    path: "/signup",
    component: lazy(() => import("../views/Signup/Signup")),
    roles: [roles.ADMINISTRATOR]
  },
  {
    path: "/bidashboards/investment",
    component: lazy(() => import("../views/BIDashboards/Investment")),
    roles: [roles.AZET]
  },
  // {
  //   path: "/bidashboards/servicingreport",
  //   component: lazy(() => import("../views/BIDashboards/ServicingReport")),
  //   roles: [roles.AZET]
  // },
  // {
  //   path: "/bidashboards/riskanalysis",
  //   component: lazy(() => import("../views/BIDashboards/RiskAnalysis")),
  //   roles: [roles.AZET]
  // },
  {
    path: "/bidashboards/portfolioreport",
    component: lazy(() => import("../views/BIDashboards/PortfolioReport")),
    roles: [roles.AZET]
  },
  {
    path: "/bidashboards/loansweeklyreconciliation",
    component: lazy(() => import("../views/BIDashboards/LoansWeeklyReconciliation")),
    roles: [roles.AZET, roles.PARTNER]
  },
  // {
  //   path: "/bidashboards/covenantbreachesanalysis",
  //   component: lazy(() => import("../views/BIDashboards/CovenantBreachesAnalysis")),
  //   roles: [roles.AZET, roles.PARTNER]
  // },  
];

export function getRouteByPathname(pathName) {

  const matchedRoute = routes.find(route => {

    // Normalize the path: Remove "/app" if it exists, and ensure lowercase
    let normalizedPath = pathName.toLowerCase().replace(/^\/app/, "");
    // Convert dynamic parameters ":param" into regex wildcards "[^/]+"
    const regexPath = route.path.replace(/:\w+/g, "[^/]+");
    // Ensure full match
    const regex = new RegExp(`^${regexPath}$`, "i");
    return regex.test(normalizedPath);
  });

  // Return matched route or null if no match
  return matchedRoute || null;
}

export default routes;
